/**
 * PublicLayout Component
 *
 * Layout wrapper for public pages (landing, venues, legal pages, auth).
 * Includes footer with support and legal links.
 */

import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Footer } from '../Footer';
import { LandingNavbar } from '../../features/landing/components/LandingNavbar';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Header with CitySwitcher for public/guest pages */}
      <LandingNavbar transparent={false} />

      {/* Main content */}
      <Box sx={{ flex: 1 }}>{children}</Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
}
